module.exports = __webpack_public_path__ + "Flag-316.91ce4516f742cdc5dcdadfbfe7d32a46.svg";